import { Component, Input } from '@angular/core';
import { UserStatus, UserStatusPresentation } from '../../../enums/user-status.enum';

@Component({
  selector: 'app-account-status',
  templateUrl: './account-status.component.html',
  styleUrls: ['./account-status.component.scss'],
  standalone: false
})
export class AccountStatusComponent {
  public readonly UserStatus = UserStatus;
  public readonly UserStatusPresentation = UserStatusPresentation;

  @Input()
  public status: UserStatus;
}
